module.exports = __webpack_public_path__ + "img/farende-svend1.5905f49d.jpg";